export default __webpack_public_path__ + "static/media/ponder-bg-l.d1e63a30.svg";